(function () {
  const container = document.querySelector('[data-latest-posts]');
  if (!container) return;

  const LIMIT = Number(container.dataset.limit || 5);
  const EXCLUDE_ID = String(container.dataset.excludeId || '');
  const DEFAULT_IMAGE = container.dataset.defaultImage || '';
  const BLOG_HANDLES_FROM_LIQUID = (container.dataset.blogHandles || '')
    .split(',')
    .map((handle) => handle.trim())
    .filter(Boolean);
  const CURRENT_BLOG_HANDLE = (container.dataset.currentBlogHandle || '').trim();

  async function discoverBlogHandlesFromSitemap() {
    try {
      const response = await fetch('/sitemap_blogs_1.xml');

      if (!response.ok) {
        return [];
      }

      const text = await response.text();
      const handles = new Set();

      for (const match of text.matchAll(/\/blogs\/([^/?#'"\s]+)/g)) {
        handles.add(match[1]);
      }

      return [...handles];
    } catch (error) {
      console.warn('[latest-posts] Could not read blog sitemap.', error);
      return [];
    }
  }

  async function getBlogHandles() {
    const fromSitemap = await discoverBlogHandlesFromSitemap();
    const handles = new Set([...BLOG_HANDLES_FROM_LIQUID, ...fromSitemap]);

    if (handles.size === 0 && CURRENT_BLOG_HANDLE) {
      handles.add(CURRENT_BLOG_HANDLE);
    }

    return [...handles];
  }

  async function fetchArticlesForBlog(handle) {
    const response = await fetch(`/blogs/${handle}?view=latest-posts`);

    if (!response.ok) {
      throw new Error(`HTTP ${response.status} for blog ${handle}`);
    }

    const json = await response.json();

    return (json.articles || []).map((article) => ({
      id: String(article.id),
      title: article.title,
      publishedAt: article.published_at,
      url: article.url,
      image: article.image
        ? {
            url: article.image.src,
            altText: article.image.alt || article.title,
          }
        : null,
    }));
  }

  async function fetchLatestArticles(handles) {
    const results = await Promise.all(
      handles.map((handle) =>
        fetchArticlesForBlog(handle).catch((error) => {
          console.warn(`[latest-posts] Failed to fetch blog: ${handle}`, error);
          return [];
        })
      )
    );

    return results.flat();
  }

  function formatDate(isoString) {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderArticles(articles) {
    container.innerHTML = articles
      .map(
        (article) => `
      <div class="blogList__unit">
        <a href="${article.url}">
          <div class="blogList__imageBox">
            <img
              class="blogList__image"
              src="${article.image?.url || DEFAULT_IMAGE}"
              alt="${escapeHtml(article.image?.altText || article.title)}"
              loading="lazy"
              width="165"
              height="165"
            >
          </div>
          <div class="blogList__title">${escapeHtml(article.title)}</div>
          <div class="blogList__footer">
            <div class="blogList__date">${formatDate(article.publishedAt)}</div>
          </div>
        </a>
      </div>
    `
      )
      .join('');
  }

  async function init() {
    try {
      const blogHandles = await getBlogHandles();

      if (blogHandles.length === 0) {
        throw new Error('No blog handles found.');
      }

      const allArticles = await fetchLatestArticles(blogHandles);

      const latest = allArticles
        .filter((article) => article.id !== EXCLUDE_ID)
        .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt))
        .slice(0, LIMIT);

      if (latest.length === 0) {
        container.closest('#latest_posts')?.remove();
        return;
      }

      renderArticles(latest);
      container.dispatchEvent(new CustomEvent('latest-posts:rendered', { bubbles: true }));
    } catch (error) {
      console.error('[latest-posts]', error);
      container.closest('#latest_posts')?.remove();
    }
  }

  init();
})();
